import Input from 'components/Form/Input'
import { TotalOfferText } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/RoleDetails/style'
import { FormItem } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import React from 'react'
import { TotalTimeDiv } from '../../../ScheduleInterviewDrawer/style'

const RoleDetails = ({rolesMetrics}) => {

  return (
    <>
      <FormItem>
        <TotalOfferText>Role</TotalOfferText>
        <Input
          width="100%"
          placeholder="Role"
          value={rolesMetrics?.[0]?.roleName}
          disabled={true}
        />
      </FormItem>
      <FormItem>
        <TotalOfferText>Designation </TotalOfferText>
        <Input
          width="100%"
          placeholder="Designation"
          name={'designation'}
          rules={[
            {
              required: true,
              message: 'Please enter designation!',
            },
          ]}
        />
      </FormItem>
      <FormItem>
        <TotalTimeDiv>Job Location *</TotalTimeDiv>
        <Input
           width="100%"
           placeholder="Chennai"
           name={'jobLocation'}
           rules={[
          {
            required: true,
            message: 'Please enter job location!',
          },
        ]}
          />
      </FormItem>
    </>
  )
}

export default RoleDetails
